import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnExpander, ColumnNameH2H, ColumnBib } from "components/common/TableColumns"
import StatsBox from "components/sports/bkb/views/StatsBox"
import { dateFormat } from "helpers/utils"
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TableColumns = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber' }),
      ColumnNameH2H({ showCaptainAbbr: true, showDisciplineClass: true, showSuspendedCode: true, hideNoc: true }),
      ColumnPosition({}),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}

export function ColumnPosition({
  disableSort = true,
  className = 'text-start',
  headerClassName = 'text-end w-10',
  label = 'PlayingPosition',
  code = 'Position'
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'functionDescription',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: code
    }
  )
}

const getConfigurationBox = (date) => {

  const formatedDate = date ? dateFormat(date, "", "D MMM H:mm") : "";

  let configuration = {
    header: `Current Tournament Statistics - ${formatedDate}`,
    stats: [
      {
        order: 1,
        code: 'MP',
        attr: 'value',
        label: 'StatsGamesPlayed',
        title: 'Games played'
      },
      {
        order: 2,
        code: 'PTS_AVG',
        attr: 'value',
        label: 'StatsPointsGame',
        title: 'Points per Game'
      },
      {
        order: 3,
        code: 'PLUS_MINUS',
        attr: 'value',
        label: 'StatsPlusMinusGame',
        title: 'Plus-Minus per Game'
      },
      {
        order: 4,
        code: 'FG',
        attr: 'percent',
        label: 'StatsFieldGoals',
        title: 'Field Goals %'
      },
      {
        order: 5,
        code: 'P3_AVG',
        attr: 'value',
        label: 'Stats3Point',
        title: '3-Point Field Goals %'
      },
      {
        order: 6,
        code: 'FT_AVG',
        attr: 'value',
        label: 'StatsFreeThrows',
        title: 'Free Throws %'
      },
      {
        order: 7,
        code: 'REB',
        attr: 'value',
        label: 'StatsReboundsGame',
        title: 'Rebounds per Game'
      },
      {
        order: 8,
        code: 'ASSIST',
        attr: 'value',
        label: 'StatsAssistsGame',
        title: 'Assists per Game'
      },
      {
        order: 9,
        code: 'MINS',
        attr: 'value',
        label: 'StatsMinutesPlayed',
        title: 'Minutes Played per Game'
      }
    ]
  }
  return configuration;
}

const getConfiguration = (data, breakPoint) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.caption = (

    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc className='me-1' {...data?.participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...data?.participant} />
      </strong>
    </div>
  )

  configuration.columns = TableColumns();

  return configuration;
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEvent = useMemo(() => getConfiguration(data, breakPoint));

  const configBox = useMemo(() => getConfigurationBox(date));

  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <StatsBox data={row?.original?.cumStatsItems} config={configBox} breakPoint={breakPoint} />
    }
    />
  ), [resultStatus]);

  //console.log(data.teamAthletes);
  //console.log(data);

  return (<>
    {data.teamAthletes && (
      <div className="start-list-side-main">
        <div className="row">
          <div className="col-12">
            <MirsTable
              className={"table-start-list"}
              id={`mirs-table-start-list-${mirs_rsc}-${data?.participant?.code}`}
              data={data.teamAthletes}
              columns={configEvent.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEvent.caption}
              initialSortBy={configEvent.sortBy}
            />
          </div>
        </div>
      </div>
    )
    }
  </>)
}

export default StartListSide;
